import { FeatureFlags } from '../models/FeatureFlags';
import { createReducer, on } from '@ngrx/store';
import { FeatureFlagActions } from '../actions';

export const flagsKey = 'flags';

export interface State extends FeatureFlags {}

export const initialFeatureFlagState: State = {
  disableDisplayL2Tabs: false,
  enableTotalDistSloaBsloaIt: false,
  enablePALCreateWireTrxn: false,
  createSloaToggleForCreateRulesEnabled: false,
  enableRecurringChecksStandingAuth: false,
  enableAchPath: false,
  enableWiresCondensedLayout: false,
  enableSpecialStateTax: false,
  enableCodeY4RecurringChecks: false,
  enableUseSloaContainer: false,
};

export const featureFlagReducer = createReducer(
  initialFeatureFlagState,
  on(FeatureFlagActions.setFlag, (state, { name, value, defaultValue }) => {
    return {
      ...state,
      [name]: value ?? defaultValue,
    };
  })
);
